module.exports = __webpack_public_path__ + "img/2355f61.png";